import React from 'react';
import { Link } from 'react-router-dom';

const events = [
  { icon: '🎂', name: 'Birthday Parties', desc: 'Make your special day unforgettable with our curated menus', img: 'https://images.unsplash.com/photo-1530103862676-de8c9debad4d?w=600&q=80' },
  { icon: '💼', name: 'Corporate Events', desc: 'Impress clients and teams with premium dining experiences', img: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=600&q=80' },
  { icon: '👶', name: 'Baby Showers', desc: 'Celebrate new beginnings in our elegant private spaces', img: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80' },
  { icon: '🎓', name: 'Graduations', desc: 'Honor achievements with a feast worth celebrating', img: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=600&q=80' },
  { icon: '💍', name: 'Weddings', desc: 'Your dream wedding reception starts here', img: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80' },
  { icon: '🎊', name: 'Private Dining', desc: 'Exclusive spaces for intimate gatherings of 10-200 guests', img: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80' },
];

const EventsSection = () => (
  <section className="section-padding" style={{ backgroundColor: '#ffffff' }}>
    <div className="container">
      <div className="text-center mb-5 reveal">
        <span className="section-subtitle">Celebrate With Us</span>
        <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600 }}>
          Events & Private Dining
        </h2>
        <div className="gold-divider-center"></div>
        <p style={{ fontSize: '1.05rem', color: '#777', maxWidth: '600px', margin: '16px auto 0' }}>
          Perfect for intimate gatherings of 10 to 200 guests.
        </p>
      </div>
      <div className="row g-4">
        {events.map((event, i) => (
          <div key={i} className="col-md-6 col-lg-4 reveal" style={{ transitionDelay: `${i * 0.1}s` }}>
            <div className="event-card">
              <img src={event.img} alt={event.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} loading="lazy" />
              <div className="event-overlay">
                <span style={{ fontSize: '1.5rem', marginBottom: '8px' }}>{event.icon}</span>
                <h5 className="text-white mb-2" style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600 }}>{event.name}</h5>
                <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem', lineHeight: 1.6, marginBottom: '12px' }}>{event.desc}</p>
                <Link to="/booking" className="btn btn-sm" style={{
                  backgroundColor: '#D4AF37', color: '#fff', padding: '8px 20px',
                  fontSize: '0.75rem', borderRadius: '8px', letterSpacing: '1px', alignSelf: 'flex-start'
                }}>Enquire Now</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default EventsSection;
